import { render } from "./HomeMixRawMaterialsTable.vue?vue&type=template&id=6fc06b5a&ts=true"
import script from "./HomeMixRawMaterialsTable.vue?vue&type=script&lang=ts"
export * from "./HomeMixRawMaterialsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__